export default __webpack_public_path__ + "static/media/hotel_img_hi_23.e88940fb.jpg";